// extracted by mini-css-extract-plugin
module.exports = {"CookieBanner":"kVdv3U","slideDown":"rjoxDa","Title":"pnU8Yy","Paragraph":"V5Ql6C"};